import React from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { CATEGORIES } from "@/lib/categories";

export default function CategoryBar({ variant = "landing" }) {
  const loc = useLocation();
  const [params] = useSearchParams();
  const activeSlug = params.get("cat") || (loc.pathname.startsWith("/catalogue") ? null : null);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-12 py-8 md:py-12" data-testid="category-bar">
      {variant === "landing" && (
        <div className="text-center mb-8">
          <div className="ornament mb-3" style={{ color: "#A88934" }}>Browse by craft</div>
          <h2 className="font-display text-3xl md:text-4xl" style={{ fontWeight: 400, color: "#0B1A33" }}>
            Find your kind of piece.
          </h2>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4" data-testid="category-grid">
        <CategoryTile to="/catalogue" label="All" active={!activeSlug} />
        {CATEGORIES.map((c) => (
          <CategoryTile
            key={c.slug}
            to={`/catalogue?cat=${c.slug}`}
            label={c.label}
            Icon={c.icon}
            active={activeSlug === c.slug}
          />
        ))}
      </div>
    </section>
  );
}

const CategoryTile = ({ to, label, Icon, active }) => (
  <Link
    to={to}
    data-testid={`cat-tile-${label.toLowerCase().replace(/\s|&/g, "-")}`}
    className={`group flex flex-col items-center justify-center gap-2 py-5 px-3 border transition-all duration-300 text-center min-h-[88px] ${
      active
        ? "border-gold bg-gold/10"
        : "border-gold/25 bg-white hover:border-gold hover:bg-gold/5"
    }`}
    style={{ color: "#0B1A33" }}
  >
    {Icon ? (
      <Icon
        className="w-5 h-5 transition-colors"
        strokeWidth={1.4}
        style={{ color: active ? "#A88934" : "#C9A84C" }}
      />
    ) : (
      <span className="w-5 h-5 flex items-center justify-center text-xs font-bold" style={{ color: active ? "#A88934" : "#C9A84C" }}>★</span>
    )}
    <span className="text-[11px] md:text-xs tracking-[0.18em] uppercase font-medium leading-tight">{label}</span>
  </Link>
);
